import React from 'react';
import StyledTitle from '../../Shared/StyledTitle/StyledTitle';
import './Syles/Banner.scss';
import StyledLink from '../../Shared/StyledLink/StyledLink';
import image from '../../../Assets/Cards/banner1Dashboard.webp';
import Tilt from 'react-parallax-tilt';
const Banner=()=>{
    return(
        <div className="home-banner">
            <div className="content">
               <StyledTitle 
               title="Host your designs collaboration made easy"
               desc="HostDesign makes it super easy to upload your design and share them to get any feedback from friends or collegues.
               "/>
               <div className="btns">
                   <StyledLink btn="Signup for free"  />
                  
               </div>
            </div>
<div data-aos="zoom-in"
              data-aos-delay={100}>
 <Tilt scale={0.9} transitionSpeed={3500}>
<img src={image} />
</Tilt>
</div>
        </div>
    )
};
export default Banner ;